export default function (item) {
  return item.sourceEntity.id;
}
